import { ActionTypes } from './constants'

const initialState = {
    currentLocation: {lat: null, lng: null},
    tempForm: {}
};

const MgtStationReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SET_CURRENT_LOCATION:
            return { ...state, currentLocation: payload }
        case ActionTypes.SET_TEMP_FORM:
            return { ...state, tempForm: payload }
        default:
            return state;
    }
};

export default MgtStationReducer;